<mat-card appearance="outlined">
    <mat-card-header>
        <mat-card-title>Logs</mat-card-title>
    </mat-card-header>

    <mat-card-content class="mt-4 h-96 overflow-auto">

        @for (webjobLog of webjobLogs(); track trackByLog($index, webjobLog)) {

        <div class="flex gap-4">

            @if (webjobLog.status?.case === 'success') {
            <div class="text-success"><mat-icon>check_circle</mat-icon></div>
            } @else if (webjobLog.status?.case === 'failure') {
            <div class="text-error"><mat-icon>cancel</mat-icon></div>
            } @else {
            <div><mat-icon>info</mat-icon></div>
            }

            <div class="mb-4 flex flex-col gap-2">
                <div>
                    [{{ webjobLog.name || 'Log Entry' }}]
                    <span class="text-sm"> - {{ webjobLog.status?.case }}</span>
                </div>

                <div class="text-sm">
                    ({{ webjobLog.type?.value }})
                    {{ webjobLog.createdAt?.value | date:'d-MMM-yyyy HH:mm:ss' }}
                </div>

                <div class="inline-block text-wrap">
                    {{ webjobLog.details }}
                </div>

            </div>
        </div>

        }


        @if(webjobLogsRx.isLoading()) {
        <p>loading...</p>
        }
    </mat-card-content>
</mat-card>
